<template>
  <RevIllustration
    v-if="item.kind === 'image' && isStatic"
    alt=""
    class="block w-full rounded-lg object-cover aspect-square"
    :height="item.size === 'large' ? 480 : 240"
    :src="item.image.src"
    :width="item.size === 'large' ? 480 : 240"
  />
  <button
    v-else-if="item.kind === 'image'"
    :aria-label="imageAriaLabel"
    class="block w-full text-start"
    type="button"
    @click="emit('image-click', item.image)"
  >
    <RevIllustration
      alt=""
      class="block w-full rounded-lg object-cover aspect-square"
      :height="item.size === 'large' ? 480 : 240"
      :src="item.image.src"
      :width="item.size === 'large' ? 480 : 240"
    />
  </button>
  <RevIllustration
    v-else-if="item.kind === 'review' && isStatic"
    alt=""
    class="block w-full rounded-lg object-cover aspect-square"
    :height="240"
    :src="item.review.pictures?.[0] || ''"
    :width="240"
  />
  <slot
    v-else-if="item.kind === 'review'"
    name="review"
    :review="item.review"
    :size="item.size"
  >
    <GalleryReviewItem
      :aria-label="reviewAriaLabel"
      :review="item.review"
      @visible="emit('review-visible', item.review)"
    />
  </slot>
  <RevSkeleton
    v-else-if="item.kind === 'skeleton'"
    class="aspect-square size-full rounded-lg"
    shape="rectangle"
  />
  <RevIllustration
    v-else-if="item.kind === 'video' && isStatic"
    alt=""
    class="block w-full rounded-lg object-cover aspect-square"
    :height="240"
    :src="item.video.src"
    :width="240"
  />
  <slot v-else-if="item.kind === 'video'" name="video" :video="item.video">
    <GalleryVideoItem
      :aria-label="videoAriaLabel"
      :is-mobile
      @click="emit('video-click', item.video)"
      @start="emit('video-start')"
    />
  </slot>
</template>

<script setup lang="ts">
import { RevIllustration } from '@ds/components/Illustration'
import { RevSkeleton } from '@ds/components/Skeleton'

import type { ReviewWithCount } from '~/scopes/product-core/components/presentationals/GalleryNew/GalleryNew.types'
import type {
  ProductDetailPageGalleryImage,
  ProductDetailPageGalleryItem,
  ProductDetailPageGalleryVideo,
} from '~/scopes/product-core/components/presentationals/ProductDetailPageGallery/ProductDetailPageGallery.types'
import GalleryReviewItem from '~/scopes/product-core/components/presentationals/ProductDetailPageGallery/components/GalleryReviewItem/GalleryReviewItem.vue'
import GalleryVideoItem from '~/scopes/product-core/components/presentationals/ProductDetailPageGallery/components/GalleryVideoItem/GalleryVideoItem.vue'

withDefaults(
  defineProps<{
    item: ProductDetailPageGalleryItem
    isStatic?: boolean
    imageAriaLabel?: string
    videoAriaLabel?: string
    reviewAriaLabel?: string
    isMobile?: boolean
  }>(),
  {
    isStatic: false,
    imageAriaLabel: undefined,
    videoAriaLabel: undefined,
    reviewAriaLabel: undefined,
    isMobile: false,
  },
)

const emit = defineEmits<{
  (e: 'image-click', image: ProductDetailPageGalleryImage): void
  (e: 'review-click', review: ReviewWithCount): void
  (e: 'review-visible', review: ReviewWithCount): void
  (e: 'video-click', video: ProductDetailPageGalleryVideo): void
  (e: 'video-start'): void
}>()
</script>
